import { render, staticRenderFns } from "./InputfieldFieldset.vue?vue&type=template&id=53f44e82&"
import script from "./InputfieldFieldset.vue?vue&type=script&lang=js&"
export * from "./InputfieldFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports